import {
  AuthorizationAPIClient,
  AuthorizationCredentialsService,
  AuthorizationStorage,
} from 'frontcore/domain/authorization/model/AuthorizationService.d'

export class AuthorizationError extends Error {}

export default class AuthorizationLoginService implements AuthorizationCredentialsService {

  authorizationAPIClient: AuthorizationAPIClient
  storage: AuthorizationStorage

  constructor (
    storage: AuthorizationStorage,
    authorizationAPIClient: AuthorizationAPIClient
  ) {
    this.authorizationAPIClient = authorizationAPIClient
    this.storage = storage
  }

  async login (username: string, password: string, applicationId?: string): Promise<void> {
    try {
      const payload = { username, password, webapp: applicationId }
      const token = await this.authorizationAPIClient.login(payload)
      this.storage.set(token)
    } catch (e) {
      this.storage.clear()
      throw e
    }
  }

  logout () {
    this.storage.clear()
  }

}
